import { getAwsCredentials } from 'src/lib/livyCredentials';
import { signRequest } from 'src/lib/sigv4';

/**
 * The chat proxy is an IAM-authenticated Lambda function URL, so a request has to be SigV4-signed
 * with credentials the identity pool issues for the signed-in user. That means an unauthenticated
 * visitor never gets credentials and never reaches the function.
 *
 * SigV4 owns the Authorization header, so the user's Cognito token travels in x-livy-authorization.
 */

export async function livyFetch(_ref, idToken, init) {
  var _init$path;
  let endpoint = _ref.endpoint,
    region = _ref.region,
    identityPoolId = _ref.identityPoolId,
    userPoolId = _ref.userPoolId;
  const credentials = await getAwsCredentials(idToken, {
    region,
    identityPoolId,
    userPoolId
  });
  const url = new URL((_init$path = init.path) !== null && _init$path !== void 0 ? _init$path : '/', endpoint).toString();
  const headers = await signRequest({
    method: init.method,
    url,
    headers: {
      'content-type': 'application/json',
      'x-livy-authorization': "Bearer ".concat(idToken)
    },
    body: init.body,
    credentials,
    region,
    service: 'lambda'
  });
  return fetch(url, {
    method: init.method,
    headers,
    body: init.body,
    signal: init.signal
  });
}

/**
 * Build-time config. Read once here so no component has to know the chat proxy is a signed Lambda
 * URL rather than an ordinary API.
 */
export const livyConfig = () => {
  var _process$env$LIVY_REG;
  const endpoint = process.env.LIVY_CHAT_ENDPOINT;
  const identityPoolId = process.env.LIVY_IDENTITY_POOL_ID;
  const userPoolId = process.env.LIVY_USER_POOL_ID;
  const region = (_process$env$LIVY_REG = process.env.LIVY_REGION) !== null && _process$env$LIVY_REG !== void 0 ? _process$env$LIVY_REG : 'us-east-2';
  // Missing config means the surface is simply not deployed in this environment.
  return endpoint && identityPoolId && userPoolId ? {
    endpoint,
    region,
    identityPoolId,
    userPoolId
  } : null;
};